import { render, staticRenderFns } from "./LeaveBalanceSummaryWidget.vue?vue&type=template&id=5d2fde20&"
import script from "./LeaveBalanceSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./LeaveBalanceSummaryWidget.vue?vue&type=script&lang=js&"
import style0 from "./LeaveBalanceSummaryWidget.vue?vue&type=style&index=0&id=5d2fde20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports